import type { Store } from "~/models/Store"
import { STORE_CHANGED_EVENT } from "~/composables/useStoreChanges"

// Type definition for the event bus
interface EventBus {
    $on: (event: string, callback: (...args: any[]) => void) => void
    $off: (event: string, callback: (...args: any[]) => void) => void
    $emit: (event: string, ...args: any[]) => void
}

export const useCurrentStoreStore = defineStore("currentStore", {
    state: (): { store?: Store; loading: boolean } => ({
        store: undefined,
        loading: false,
    }),
    actions: {
        async setCurrentStore(store: Store) {
            if (this.store?.id === store.id) return

            const { post } = useOFetchCustom("set-active-store")
            this.loading = true
            post(
                { store: store.id },
                {
                    onSuccess: () => {
                        this.store = store

                        // Emit event for subscribers
                        const nuxtApp = useNuxtApp()
                        if (nuxtApp.$bus) {
                            ;(nuxtApp.$bus as EventBus).$emit(
                                STORE_CHANGED_EVENT
                            )
                        }

                        // Still refresh Nuxt data for backward compatibility
                        refreshNuxtData()
                    },
                    onFinish: () => {
                        this.loading = false
                    },
                }
            )
        },
        clearCurrentStore() {
            this.store = undefined
        },
    },
})
